import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- SEO & Performance Meta Tags ---
document.documentElement.lang = 'es';
document.title = 'Método Elite AT — Sistema 360 de Gestión Clínica para Acompañantes Terapéuticos';
// Meta description
const metaDesc = document.createElement('meta');
metaDesc.name = 'description';
metaDesc.content = 'El sistema completo de gestión clínica para Acompañantes Terapéuticos. 8 módulos + bonos para cobrar a término, hacer informes impecables y trabajar con seguridad profesional.';
document.head.appendChild(metaDesc);
// Viewport (ensure it exists)
if (!document.querySelector('meta[name="viewport"]')) {
  const viewport = document.createElement('meta');
  viewport.name = 'viewport';
  viewport.content = 'width=device-width, initial-scale=1';
  document.head.appendChild(viewport);
}
// Charset
if (!document.querySelector('meta[charset]')) {
  const charset = document.createElement('meta');
  charset.setAttribute('charset', 'UTF-8');
  document.head.prepend(charset);
}
// Open Graph tags
const ogTags: Record<string, string> = {
  'og:title': 'Método Elite AT — Sistema 360 de Gestión Clínica',
  'og:description': 'El sistema completo para Acompañantes Terapéuticos. Cobrá a término, hacé informes impecables y trabajá con seguridad profesional.',
  'og:type': 'website',
  'og:image': 'https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg'
};
Object.entries(ogTags).forEach(([property, content]) => {
  const tag = document.createElement('meta');
  tag.setAttribute('property', property);
  tag.content = content;
  document.head.appendChild(tag);
});
// Preconnect for Google Fonts
const preconnectGoogle = document.createElement('link');
preconnectGoogle.rel = 'preconnect';
preconnectGoogle.href = 'https://fonts.googleapis.com';
document.head.prepend(preconnectGoogle);
const preconnectGstatic = document.createElement('link');
preconnectGstatic.rel = 'preconnect';
preconnectGstatic.href = 'https://fonts.gstatic.com';
preconnectGstatic.crossOrigin = 'anonymous';
document.head.prepend(preconnectGstatic);
// Load Google Fonts ASYNCHRONOUSLY (non-blocking — key performance fix)
const fontsLink = document.createElement('link');
fontsLink.rel = 'stylesheet';
fontsLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap';
fontsLink.media = 'print'; // non-blocking: browser won't wait for this
fontsLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
}; // swap to "all" once loaded
document.head.appendChild(fontsLink);
// Preload hero image (LCP element) for faster rendering
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg';
document.head.appendChild(preloadHero);
// Robots meta
const robots = document.createElement('meta');
robots.name = 'robots';
robots.content = 'index, follow';
document.head.appendChild(robots);
// Structured data (Product) for rich search results
const jsonLd = document.createElement('script');
jsonLd.type = 'application/ld+json';
jsonLd.textContent = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Método Elite AT — Sistema 360 de Gestión Clínica',
  description: 'El sistema completo de gestión clínica para Acompañantes Terapéuticos. 8 módulos + bonos para cobrar a término, hacer informes impecables y trabajar con seguridad profesional.',
  image: 'https://cdn.magicpatterns.com/uploads/4NBivHLYcJVWbDizd4Wcwp/formato_1_a_1.png',
  offers: [{
    '@type': 'Offer',
    name: 'Pack Base AT',
    price: '19990',
    priceCurrency: 'ARS',
    availability: 'https://schema.org/InStock',
    url: 'https://fegion.shop/cart/46280111620235:1'
  }, {
    '@type': 'Offer',
    name: 'Combo Élite AT',
    price: '29990',
    priceCurrency: 'ARS',
    availability: 'https://schema.org/InStock',
    url: 'https://fegion.shop/cart/46280115159179:1'
  }]
});
document.head.appendChild(jsonLd);
// --- End SEO & Performance ---
// --- Meta Pixel 904978025482552 ---
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
;
(function (f: any, b: any, e: any, v: string) {
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  const s = b.getElementsByTagName(e)[0];
  s?.parentNode?.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '904978025482552');
window.fbq('track', 'PageView');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
document.body.appendChild(img);
// --- End Meta Pixel ---
render(<App data-id="element-377" />, document.getElementById('root'));